// Per-location Meta Pixel helper.
// initPixel(id) injects the fbq base snippet once and fires PageView.
// trackPixel(event, params) fires a standard/custom event if a pixel is loaded.

export function initPixel(pixelId) {
  if (!pixelId || typeof window === "undefined") return;
  window.__fbqInitIds = window.__fbqInitIds || {};
  if (window.__fbqInitIds[pixelId]) return; // avoid double init

  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */

  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
  window.__fbqInitIds[pixelId] = true;
}

export function trackPixel(event, params) {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", event, params || {});
  }
}

// Bridge: Acuity (inside the iframe) posts a message on booking confirmation.
// We listen on the parent page and fire the Purchase event on the pixel.
// In Acuity → Integrations → Custom Conversion Tracking, paste the snippet
// that posts { event: 'acuity_booking_confirmed', id, price, appointmentType }.
export function initAcuityPurchaseBridge({ currency = "USD", fallbackValue = 0 } = {}) {
  if (typeof window === "undefined" || window.__acuityBridge) return;
  window.__acuityBridge = true;
  const seen = new Set();
  window.addEventListener("message", (event) => {
    const d = event && event.data;
    if (!d || d.event !== "acuity_booking_confirmed") return;
    if (d.id && seen.has(d.id)) return;
    if (d.id) seen.add(d.id);
    const value = parseFloat(d.price) || fallbackValue;
    trackPixel("Purchase", {
      value,
      currency,
      content_name: d.appointmentType || undefined,
    });
  });
}
